import React from 'react'
import { Icon } from 'antd'
import moment from 'moment'
import mentorsService from '@services/mentors'
import MeetingModal from '@pages/MentorsMeetings/MeetingModal'

const HIDDEN_MENTOR_VALUES = ['מדיהו קול סנטר', 'מיקי קופל']
const isHiddenMentor = (mentor: string) =>
    Boolean(mentor) && HIDDEN_MENTOR_VALUES.some(value => mentor.indexOf(value) !== -1)

// the two summary boxes in the agent's top section; the meeting form and history live in the shared modal
class AgentMeetings extends React.Component<any, any> {
    _isMounted: boolean

    constructor(props) {
        super(props)
        this._isMounted = false
        this.state = {
            visible: false,
            meetings: [],
            summaryLoading: true
        }
    }

    componentDidMount() {
        this._isMounted = true
        if (this.props.agentInfo && this.props.agentInfo.id) this.loadMeetings()
    }

    componentDidUpdate(prevProps) {
        const previousAgentId = prevProps.agentInfo && prevProps.agentInfo.id
        const currentAgentId = this.props.agentInfo && this.props.agentInfo.id

        // The top section mounts before the agent request can finish. Fetch as soon as its ID arrives,
        // rather than waiting until the meetings modal is opened.
        if (currentAgentId && currentAgentId !== previousAgentId) {
            this.loadMeetings()
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    // feeds the "next / last meeting" box only — the modal loads its own copy of the list
    loadMeetings = () => {
        const agentId = this.props.agentInfo && this.props.agentInfo.id
        if (!agentId) return

        this.setState({ summaryLoading: true })
        mentorsService
            .getAgentMeetings(agentId)
            .then(res => {
                if (!this._isMounted) return
                const data = res.data || {}
                this.setState({ meetings: data.meetings || [], summaryLoading: false })
            })
            .catch(() => {
                if (this._isMounted) this.setState({ summaryLoading: false })
            })
    }

    // the modal changed something, so the box above it is stale too
    handleChanged = () => {
        this.loadMeetings()
        if (this.props.updateInfo) this.props.updateInfo()
    }

    render() {
        const { agentInfo = {} } = this.props
        const { visible, meetings, summaryLoading } = this.state

        const now = moment()
        const nextMeeting = meetings
            .filter(m => moment(m.meeting_time).isAfter(now))
            .sort((a, b) => moment(a.meeting_time).valueOf() - moment(b.meeting_time).valueOf())[0]
        const lastOccurredMeeting = meetings
            .filter(m => moment(m.meeting_time).isSameOrBefore(now))
            .sort((a, b) => moment(b.meeting_time).valueOf() - moment(a.meeting_time).valueOf())[0]
        const lastOccurred = lastOccurredMeeting ? moment(lastOccurredMeeting.meeting_time) : null

        return (
            <div style={{ display: 'flex' }}>
                {!isHiddenMentor(agentInfo.mentor) && (
                    <>
                        <div style={{ ...style.box, ...style.rightBox }}>
                            {summaryLoading ? (
                                <Icon type="loading" />
                            ) : (
                                <span>
                                    {nextMeeting
                                        ? `פגישה הבאה: ${moment(nextMeeting.meeting_time).format('DD/MM/YYYY')}`
                                        : lastOccurred
                                        ? `פגישה אחרונה: ${lastOccurred.format('DD/MM/YYYY')}`
                                        : 'אין תיעוד לפגישה האחרונה'}
                                </span>
                            )}
                        </div>
                        {/* the two boxes looked identical, but only this one is clickable — icon + hover mark it as the action */}
                        <div
                            onClick={() => this.setState({ visible: true })}
                            className="mentor-meetings-trigger"
                            style={{ ...style.box, ...style.leftBox }}
                        >
                            <Icon type="plus" style={{ ...style.iconFix, marginInlineEnd: 6 }} />
                            <span>{'יצירת פגישה חדשה'}</span>
                        </div>
                    </>
                )}

                <MeetingModal
                    mode="agent"
                    agentInfo={agentInfo}
                    visible={visible}
                    onClose={() => this.setState({ visible: false })}
                    onCreated={this.handleChanged}
                />
            </div>
        )
    }
}

const style = {
    // cancels the global .anticon { top: -0.2rem } rule so icons sit on the text baseline here
    iconFix: { top: '1px' },
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    },
    rightBox: { borderRadius: '0 4px 4px 0', cursor: 'default' },
    leftBox: { borderRadius: '4px 0 0 4px' }
}

export default AgentMeetings
